import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import DemoScripts from "./DemoScripts";
import Licenses from "./Licenses";
import Main from "./Main";
import PlatformOverview from "./PlatformOverview";
import Tenant from "./Tenant";
import TenantList from "./TenantList";
import User from "./User";

const Router: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route path="tenants" element={<TenantList />} />
          <Route path="tenants/:tenantId" element={<Tenant />} />
          <Route path="platform" element={<PlatformOverview />} />
          <Route path="users" element={<User />} />
          <Route path="licenses" element={<Licenses />} />
          <Route path="demo-scripts" element={<DemoScripts />} />
          <Route index element={<Navigate to="tenants" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
